import { useState } from 'react';

import { VoucherType } from '@/types';
import { useReward } from '@/contexts/reward-context';

import { RewardModalWrapper } from '@/components/reward-modal-wrapper';
import { CloseIcon } from '@/components/svg-icons';
import { EventVoucherIcon } from '@/components/icons/event-voucher-icon';
import { Event3dButton } from '@/components/buttons/event-3d-button';
export const OddsBoosterGift = () => {
	const {
		labels,
		promotionOddsBoostInfo,
		siteId,
		onGoToLeague,
		notUsedVoucherData,
		fetchRewardInfoThenUpdate,
		receiveWeeklyAward,
		onClose,
		onKafkaSet
	} = useReward();
	const [claimed, setClaimed] = useState(false);

	const claim = () => {
		if (claimed) return;

		receiveWeeklyAward().then(() => {
			setClaimed(true);
			fetchRewardInfoThenUpdate();
		});
	};

	const useVoucher = async () => {
		onKafkaSet({
			type: 9,
			action: 2
		});
		if (!notUsedVoucherData) return;
		try {
			switch (notUsedVoucherData?.VoucherType) {
				case VoucherType.FreeOddsBooster:
					await onGoToLeague?.({ sport: 1, leagueId: [3] });
					break;
				case VoucherType.AffPromotionOddsBoost:
					await onGoToLeague?.({ sport: 1, leagueId: [3, 4, 5, 8, 43] });
					break;
			}
			
			onClose();
		} catch (error) {
			console.error(error);
		}
	};

	const handleClose = () => {
		onKafkaSet({
			type: 9,
			action: 1
		});
		onClose();
	};

	const isSm88 = ['4258600', '4227600'].includes(siteId);

	return (
		<RewardModalWrapper>
			<div
				className="reward-receive"
				data-receive={claimed}
			>
				{
					isSm88 && (
						<div className="reward-receive-gift__logo-wrapper">
							<div className="reward-receive__debet-logo"></div>
						</div>
					) 
				}
				<div
					className="reward-receive__close"
					onClick={handleClose}
				>
					<CloseIcon />
				</div>
				<div className="reward-receive__main">
					<div className="reward-receive-gift reward-receive-gift--1">
						<div className="reward-receive-gift__header">
							<div className="reward-receive-gift__title">

								{
									isSm88 ?
										<>
											{labels?.lbl_DebetObp01}
											<strong>{labels?.lbl_DebetObp02}</strong>
										</>
										:
										<>
											{labels?.lbl_obp01}
											<strong>{labels?.lbl_obp02}</strong>
										</>
								}
							</div>
						</div>
						<div className="reward-receive-gift__img">
							<div className="reward-receive-gift__gift-1"></div>
						</div>
						<div className="reward-receive-gift__bg"></div>
						<div className="reward-receive__btn">
							<Event3dButton onClick={claim}>
								{ isSm88 ? labels?.lbl_DebetObp03 : labels?.lbl_obp03}
							</Event3dButton>
						</div>
					</div>
					<div className="reward-receive-gift reward-receive-gift--2">
						<div className="reward-receive-gift__header">
							<div className="reward-receive-gift__title">
								<strong>{isSm88 ? labels?.lbl_DebetObp04 : labels?.lbl_RPCongrats}</strong>
								{labels?.lbl_RPOddsBooster}
								<EventVoucherIcon voucherType={VoucherType.FreeOddsBooster} />
								x {promotionOddsBoostInfo?.GiftOddsBoostTicketCount}
							</div>
							<div className="reward-receive-gift__subtitle">
								{ isSm88 ? labels?.lbl_DebetObp05 : labels?.lbl_obp07}
							</div>
						</div>
						<div className="reward-receive-gift__img">
							<div className="reward-receive-gift__gift-2"></div>
							<div className="reward-receive-gift__light"></div>
						</div>
						<div className="reward-receive-gift__bg"></div>
						<Event3dButton onClick={useVoucher}>
							{labels?.lbl_oddspromopop02}
						</Event3dButton>
					</div>
				</div>
				{
					isSm88 && ( 
						<div className="reward-receive-gift__logo-wrapper"></div> // 為了置中reward-receive__main
					)
				}
			</div>
		</RewardModalWrapper>
	);
};